import React from 'react';
import { Hospital } from 'types/hospital';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { hospitalTableTemplate } from '../../template/hospitalTableTemplate';

type HospitalListTableProps = {
  hospitals: Hospital[];
};

const HospitalListTable: React.FC<HospitalListTableProps> = ({ hospitals }) => {
  return (
    <DataGridList
      template={hospitalTableTemplate}
      rows={hospitals}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/hospitals/${row.id}`)}
      fileName="hospitais"
      sheetName="Hospitais"
    />
  );
};

export default HospitalListTable;
